import { TaskID, ProjID } from "./constants";
export default function todoUpdates(api, resolver) {
    function resolveTaskData(obj) {
        if (!obj) {
            return null;
        }
        for (const key in obj) {
            if (typeof obj[key] == "object") {
                resolveTaskData(obj[key]);
                continue;
            }
            switch (key) {
                case "id":
                case "targetId":
                case "parent":
                    obj[key] = resolver(obj[key], TaskID) || null;
                    break;
                case "project":
                    obj[key] = resolver(obj[key], ProjID) || null;
                    break;
            }
        }
        return obj;
    }
    function tasksUpdate(obj) {
        resolveTaskData(obj);
        const { id } = obj;
        const { reverse, parent, project, targetId } = obj.data || {};
        switch (obj.type) {
            case "add-task": {
                api.exec("add-task", {
                    id,
                    project: typeof project === "undefined" ? null : project,
                    parent,
                    targetId,
                    reverse,
                    task: { ...obj.data.task },
                    skipProvider: true,
                    $meta: {
                        skipHistory: true,
                    },
                });
                break;
            }
            case "update-task":
                api.exec("update-task", {
                    id,
                    task: { ...obj.data },
                    skipProvider: true,
                    $meta: {
                        skipHistory: true,
                    },
                });
                obj?.data?.batch?.forEach((task) => {
                    api.exec("update-task", {
                        id: task.id,
                        task,
                        skipProvider: true,
                        $meta: {
                            skipHistory: true,
                        },
                    });
                });
                break;
            case "delete-task": {
                if (obj.data?.batch) {
                    obj.data.batch.forEach((id) => {
                        api.exec("delete-task", {
                            id,
                            skipProvider: true,
                            $meta: {
                                skipHistory: true,
                            },
                        });
                    });
                }
                else {
                    api.exec("delete-task", {
                        id,
                        skipProvider: true,
                        $meta: {
                            skipHistory: true,
                        },
                    });
                }
                break;
            }
            case "move-task":
                if (obj.data?.opbatch?.length) {
                    obj.data.opbatch?.forEach((op) => {
                        api.exec("move-task", {
                            ...op,
                            skipProvider: true,
                            $meta: {
                                skipHistory: true,
                            },
                        });
                    });
                }
                else if (obj?.data?.batch?.length) {
                    obj.data.batch?.forEach((id) => {
                        id = resolver(id, TaskID);
                        api.exec("move-task", {
                            id,
                            project,
                            parent,
                            targetId,
                            reverse,
                            skipProvider: true,
                            $meta: {
                                skipHistory: true,
                            },
                        });
                    });
                }
                else {
                    const { id } = obj.data;
                    api.exec("move-task", {
                        id,
                        project,
                        parent,
                        targetId,
                        reverse,
                        skipProvider: true,
                        $meta: {
                            skipHistory: true,
                        },
                    });
                }
                break;
            case "clone-task":
                for (let i = 0; i < obj?.data?.batch?.length; i++) {
                    const task = obj.data.batch[i];
                    if (i === 0) {
                        api.exec("add-task", {
                            id: task.id,
                            project,
                            parent,
                            targetId,
                            task,
                            reverse,
                            skipProvider: true,
                            $meta: {
                                skipHistory: true,
                            },
                        });
                    }
                    else {
                        api.exec("add-task", {
                            id: task.id,
                            project,
                            parent: task.parent,
                            targetId: obj.data.batch[i - 1]?.id,
                            task,
                            skipProvider: true,
                            $meta: {
                                skipHistory: true,
                            },
                        });
                    }
                }
                break;
        }
    }
    function projectsUpdate(obj) {
        const id = resolver(obj.data.id, ProjID);
        switch (obj.type) {
            case "add-project":
                api.exec("add-project", {
                    id,
                    project: {
                        label: obj.data.label,
                    },
                    skipProvider: true,
                    $meta: {
                        skipHistory: true,
                    },
                });
                break;
            case "update-project":
                api.exec("update-project", {
                    id,
                    project: {
                        label: obj.data.label,
                    },
                    skipProvider: true,
                    $meta: {
                        skipHistory: true,
                    },
                });
                break;
            case "delete-project":
                api.exec("delete-project", {
                    id,
                    skipProvider: true,
                    $meta: {
                        skipHistory: true,
                    },
                });
                break;
            case "set-sort":
                obj.data.project = resolver(obj.data.project, ProjID);
                if (api.getState().activeProject === obj.data.project) {
                    // update order in case if active project is open
                    const { by, dir } = obj.data;
                    api.exec("set-sort", {
                        by,
                        dir,
                        tree: true,
                        skipProvider: true,
                        $meta: {
                            skipHistory: true,
                        },
                    });
                }
                break;
        }
    }
    return {
        tasks: tasksUpdate,
        projects: projectsUpdate,
    };
}
//# sourceMappingURL=TodoUpdates.js.map